import buildRequest from '../buildRequest';

// Endpoints
import { typesEndpoint } from '../../../common/types';

// Libs
import { axios } from '../../../lib/axios';

// Utils
import { dataResponse, handleError } from '../../../utils';

export const getApiDetalleCotizacion = async params => {
  
  const url = typesEndpoint.getCotizaciones;

  const request = {
    idCotizacion: params,
  };

  try {
    const { data } = await axios.get(url, buildRequest(request));
    return dataResponse({ data: data });
  } catch (error) {
    return handleError(error);
  }
};
